<div class="transaction-list">
  <div class="list-heading d-flex">
    <span class="label-name">Date</span>
    <span class="label-name description">Description</span>
    <span class="label-name service-time">Period</span>
    <span class="label-name">Mode</span>
    <span class="label-name">Status</span>
    <span class="label-name">Amount</span>
  </div>
  <div class="list-content">
    <div class="list-row-wrap" *ngFor="let transaction of transactionList">
      <div
        class="close-row d-flex"
        [routerLink]="'/account/transaction/' + transaction.razor_sub_id"
      >
        <span class="date">{{
          transaction.payment
            ? (transaction.payment.created_at * 1000 | date)
            : (transaction.createdAt | date)
        }}</span>
        <div class="ids-wrap">
          <div class="order-id">
            Order ID: {{ transaction.razor_sub_id }}
            <!-- <i class="fas fa-chevron-up"></i> -->
          </div>
          <span class="transaction-id"
            >Transaction ID: {{ transaction.payment?.id }}</span
          >
        </div>
        <span class="service-time">{{
          transaction.microProduct ? "NA" : "1 Year"
        }}</span>
        <span class="mode">{{
          transaction.payment?.method | uppercase
        }}</span>
        <span
          class="status pending"
          *ngIf="
            transaction.event == 'payment.pending' &&
            transaction.payment == undefined
          "
          >Under process</span
        >
        <span
          class="status success"
          *ngIf="
            transaction.payment !== undefined &&
            (transaction.payment.status == 'authorized' ||
              transaction.payment.status === 'captured')
          "
          >ACTIVE</span
        >
        <span
          class="status failed"
          *ngIf="
            transaction.payment !== undefined &&
            transaction.payment.status == 'inactive'
          "
          >FAILED</span
        >
        <span class="amount">{{
          (transaction?.order
            ? transaction.order.amount
            : transaction.payment.amount) / 100 | pricePipe
        }}</span>
      </div>
    </div>
  </div>
</div>

